import {useConfig} from '@aboutyou/config';
import React, {FC} from 'react';
import styled from 'styled-components';
import {COLORS} from '../../../../../../constants/colors';
import {Checkbox, InputWrapper} from '../../../../../atoms/Checkbox/Checkbox';
import {NumberBadge} from '../../../../../atoms/NumberBadge/NumberBadge';
import {OnDataClickType} from './FilterGroup';

interface ItemProps {
  id: string;
  slug?: string;
  label: string;
  count?: number;
  isActive: boolean;
  onItemClick?: OnDataClickType;
  enableFilterFlyout?: boolean;
  shouldUppercaseLabel?: boolean;
}

export const FilterItem: FC<ItemProps> = ({
  id,
  label,
  count,
  slug,
  isActive,
  onItemClick,
  enableFilterFlyout = true,
  shouldUppercaseLabel,
}) => {
  const {device} = useConfig();

  return (
    <FilterCheckbox
      key={id}
      checked={isActive}
      label={
        <LabelWrapper>
          {label}
          {count !== undefined && count > 0 && (
            <Count active={isActive} count={count} size="small" />
          )}
        </LabelWrapper>
      }
      onChange={() => onItemClick?.(id, slug)}
      $smallerMargin={enableFilterFlyout}
      $largerBottomMargin={enableFilterFlyout}
      $uppercase={shouldUppercaseLabel}
      fullLabelWidth={device === 'mobile'}
    />
  );
};

const LabelWrapper = styled.div`
  display: flex;
  align-items: center;
  width: 100%;
  justify-content: space-between;
`;

const Count = styled(NumberBadge)`
  margin: 1px 0 0 0.375rem;
  white-space: nowrap;
`;

const FilterCheckbox = styled(Checkbox)<{
  $smallerMargin: boolean;
  $largerBottomMargin?: boolean;
  $uppercase?: boolean;
}>`
  margin: 0 ${props => (props.$smallerMargin ? '' : '1rem')};
  background-color: ${COLORS.White};
  display: flex;
  margin-bottom: ${props => (props.$largerBottomMargin ? '1.5rem' : '1rem')};
  contain: content;
  content-visibility: auto;
  contain-intrinsic-size: auto 60px;
  text-transform: ${props => (props.$uppercase ? 'uppercase' : 'none')};

  &[data-full-width='true'] {
    ${InputWrapper} {
      width: 100%;
    }
  }
`;
